import { get, post } from '@/common/request/index';

const OPTIONS = { isMock: false, mockId: 0, mockSuffix: '/api', needHint: true };

/** 复用移动端同一任务服务的 Web 创建入口。 */
export function createCheckSpotTask(params: any) {
  return post('/checkSpotTask/create', params, OPTIONS);
}

/** 资源库点位楼层选项。 */
export function checkSpotFloorSelection() {
  return get('/checkSpotTask/floorSelection', {}, OPTIONS);
}

/** 在所选项目下创建资源库点位。 */
export function createCheckSpotResourceSpot(params: any) {
  return post('/checkSpotTask/spot/examine', params, OPTIONS);
}

/** 与移动端共用采集固定时段。 */
export function getCheckSpotAnalysisPeriods() {
  return get('/checkSpot/device/analysisPeriodList', {}, OPTIONS);
}

/** 竞品调研品牌列表，与移动端使用同一主数据品牌库。 */
export function getCheckSpotCompetitorBrands(params: any) {
  return post('/md/brand/list', params, OPTIONS);
}
